import { render, staticRenderFns } from "./release-info.vue?vue&type=template&id=3d9682f2&scoped=true"
import script from "./release-info.vue?vue&type=script&lang=js"
export * from "./release-info.vue?vue&type=script&lang=js"
import style0 from "./release-info.vue?vue&type=style&index=0&id=3d9682f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9682f2",
  null
  
)

export default component.exports